import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ProfessorSubjectsTable from "./ProfessorSubjectsTable";
import ProfessorDetailsTable from "./ProfessorDetailsTable";
import {TabPanel} from "../Common/TabPanel";

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

const ProfessorDetailsTabsContainer = props => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="Estudiantes">
                    <Tab label="Grupos Asignados" {...a11yProps(0)} />
                    <Tab label="Detalles" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <ProfessorSubjectsTable professorId={props.professorId} history={props.history}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ProfessorDetailsTable professorMetadata={props.professorMetadata}/>
            </TabPanel>
        </div>
    );
};

export default ProfessorDetailsTabsContainer;